import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { CountryCodeSelector } from '../addedit-forms/CountryCodeSelector';
import { Coordinations } from '../addedit-forms/Coordinates';
import { CityTextField } from '../atomic-components/CityTextField';
import { PostalCodeTextField } from '../atomic-components/PostalCodeTextField';
import { AddressTextField } from '../atomic-components/AddressTextField';

export const AssetApprovalLocation = () => {
  return (
    <LaunchpadCard title={'Location'}>
      <CityTextField />
      <PostalCodeTextField />
      <CountryCodeSelector />
      <AddressTextField />
      <Coordinations />
    </LaunchpadCard>
  );
};
